module.exports = __webpack_public_path__ + "static/img/200197.a3ad3cf8.png";